import React, { useState } from "react";
import {
  Modal,
  Button,
  Card,
  Form,
  Row,
  Col,
  Badge,
  Alert,
} from "react-bootstrap";
import { IconPlus, IconEdit, IconTrash, IconX } from "@tabler/icons-react";
import AsyncSelect from "react-select/async";
import { useServiceTemplates } from "../context/ServiceTemplateContext";
// import { useInventory } from "../context/InventoryContext";
import { getRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";

const ServiceTemplateManager = ({ show, onHide }) => {
  const {
    templates,
    loading,
    error,
    createTemplate,
    updateTemplate,
    deleteTemplate,
  } = useServiceTemplates();

  // const {  } = useInventory();

  // Load inventory options for AsyncSelect
  const loadInventoryOptions = async (inputValue) => {
    try {
      // Make API call to search inventory with no pagination limit
      const queryParams = {
        search: inputValue || "",
        include: "category",
        limit: 1000, // Set high limit to get all matching results
      };

      const queryString = buildQueryString(queryParams);
      const response = await getRequest(`/inventory${queryString}`);

      if (response.success && response.data) {
        return response.data.map((item) => ({
          value: item.id,
          label: `${item.name} (${item.unit}) - ${
            item.category?.name || "No Category"
          }`,
          item: item, // Store full item data for later use
        }));
      } else {
        console.error("Failed to fetch inventory options:", response.message);
        return [];
      }
    } catch (error) {
      console.error("Error loading inventory options:", error);
      return [];
    }
  };
  const [showForm, setShowForm] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    template_items: [
      { inventory_id: "", item_name: "", quantity: 1, unit: "-" },
    ],
    // labor_ids: [],
    // labor_notes: [""],
  });

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
      template_items: [
        { inventory_id: "", item_name: "", quantity: 1, unit: "-" },
      ],
      // labor_ids: [],
      // labor_notes: [""],
    });
    setEditingTemplate(null);
    setShowForm(false);
  };

  const handleEdit = (template) => {
    setFormData({
      name: template.name,
      description: template.description,
      template_items: template.template_items || [
        { inventory_id: "", item_name: "", quantity: 1, unit: "-" },
      ],
      // labor_ids: template.labor_ids || [],
      // labor_notes: template.labor_notes || [""],
    });
    setEditingTemplate(template);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus template ini?")) {
      try {
        await deleteTemplate(id);
      } catch (err) {
        alert("Gagal menghapus template: " + err.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!formData.name.trim()) {
      alert("Nama template harus diisi");
      return;
    }

    if (
      formData.template_items.length === 0 ||
      formData.template_items.some((item) => !item.item_name.trim())
    ) {
      alert("Minimal satu item harus diisi");
      return;
    }

    try {
      const templateData = {
        ...formData,
        template_items: formData.template_items.filter((item) =>
          item.item_name.trim()
        ), // Remove empty items
        // labor_notes: formData.labor_notes.filter((note) => note.trim()), // Remove empty notes
      };

      if (editingTemplate) {
        await updateTemplate(editingTemplate.id, templateData);
      } else {
        await createTemplate(templateData);
      }

      resetForm();
    } catch (err) {
      alert("Gagal menyimpan template: " + err.message);
    }
  };

  const addItem = () => {
    setFormData((prev) => ({
      ...prev,
      template_items: [
        ...prev.template_items,
        { inventory_id: "", item_name: "", quantity: 1, unit: "-" },
      ],
    }));
  };

  const removeItem = (index) => {
    setFormData((prev) => ({
      ...prev,
      template_items: prev.template_items.filter((_, i) => i !== index),
    }));
  };

  const updateItem = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      template_items: prev.template_items.map((item, i) => {
        if (i === index) {
          return { ...item, [field]: value };
        }
        return item;
      }),
    }));
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" className="workshop-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title>Kelola Template Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <div style={{ marginBottom: "20px" }}>
          <Button
            onClick={() => setShowForm(true)}
            style={{ backgroundColor: "#059669", border: "none" }}
          >
            <IconPlus size={16} style={{ marginRight: "8px" }} />
            Tambah Template Baru
          </Button>
        </div>

        <div style={{ display: "grid", gap: "16px" }}>
          {templates.map((template) => (
            <Card key={template.id} style={{ border: "1px solid #e5e7eb" }}>
              <Card.Body>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <h5 style={{ margin: "0 0 8px 0", color: "#1f2937" }}>
                      {template.name}
                    </h5>
                    <p
                      style={{
                        margin: "0 0 12px 0",
                        color: "#6b7280",
                        fontSize: "14px",
                      }}
                    >
                      {template.description}
                    </p>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
                    >
                      {template.template_items?.map((item, index) => (
                        <Badge
                          key={index}
                          bg="secondary"
                          text="white"
                          style={{ fontSize: "12px" }}
                        >
                          {item.item_name} ({item.quantity} {item.unit})
                        </Badge>
                      ))}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => handleEdit(template)}
                    >
                      <IconEdit size={14} />
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDelete(template.id)}
                    >
                      <IconTrash size={14} />
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>

        {/* Template Form Modal */}
        <Modal show={showForm} onHide={resetForm} size="lg" className="workshop-modal-scope">
          <Modal.Header closeButton>
            <Modal.Title>
              {editingTemplate ? "Edit Template" : "Tambah Template Baru"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Nama Template</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, name: e.target.value }))
                  }
                  placeholder="Masukkan nama template"
                  required
                />
              </Form.Group>

              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Deskripsi</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={formData.description}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  placeholder="Masukkan deskripsi template"
                />
              </Form.Group>

              <Form.Group style={{ marginBottom: "16px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <Form.Label>Items Service</Form.Label>
                  <Button
                    type="button"
                    variant="outline-primary"
                    size="sm"
                    onClick={addItem}
                  >
                    <IconPlus size={14} style={{ marginRight: "4px" }} />
                    Tambah Item
                  </Button>
                </div>

                {formData.template_items.map((item, index) => (
                  <Card
                    key={index}
                    style={{ marginBottom: "8px", border: "1px solid #e5e7eb" }}
                  >
                    <Card.Body style={{ padding: "12px" }}>
                      <Row className="align-items-center">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label
                              style={{ fontSize: "12px", marginBottom: "4px" }}
                            >
                              Inventory Item
                            </Form.Label>
                            <AsyncSelect classNamePrefix="react-select" className="react-select-container"
                              cacheOptions
                              loadOptions={loadInventoryOptions}
                              defaultOptions
                              value={
                                item.inventory_id
                                  ? {
                                      value: item.inventory_id,
                                      label: `${item.item_name} (${item.unit})`,
                                      item: {
                                        id: item.inventory_id,
                                        name: item.item_name,
                                        unit: item.unit,
                                      },
                                    }
                                  : null
                              }
                              onChange={(selectedOption) => {
                                updateItem(
                                  index,
                                  "inventory_id",
                                  selectedOption?.value || ""
                                );
                                updateItem(
                                  index,
                                  "item_name",
                                  selectedOption?.item?.name || ""
                                );
                                updateItem(
                                  index,
                                  "unit",
                                  selectedOption?.item?.unit || "-"
                                );
                              }}
                              placeholder="Search inventory..."
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  minHeight: "36px",
                                  fontSize: "14px",
                                }),
                                option: (provided) => ({
                                  ...provided,
                                  fontSize: "14px",
                                }),
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={2}>
                          <Form.Label
                            style={{ fontSize: "12px", marginBottom: "4px" }}
                          >
                            Quantity
                          </Form.Label>
                          <Form.Control
                            type="number"
                            min="0.1"
                            step="0.1"
                            placeholder="Qty"
                            value={item.quantity}
                            onChange={(e) =>
                              updateItem(
                                index,
                                "quantity",
                                parseFloat(e.target.value) || 0
                              )
                            }
                          />
                        </Col>
                        <Col md={2}>
                          <Form.Label
                            style={{ fontSize: "12px", marginBottom: "4px" }}
                          >
                            Unit
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={item.unit || "-"}
                            readOnly
                            style={{ backgroundColor: "#f8f9fa" }}
                          />
                        </Col>

                        <Col md={2}>
                          {formData.template_items.length > 1 && (
                            <Button
                              type="button"
                              variant="outline-danger"
                              size="sm"
                              onClick={() => removeItem(index)}
                            >
                              <IconX size={14} />
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ))}
              </Form.Group>

              {/* <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Labor IDs (comma separated)</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.labor_ids.join(", ")}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      labor_ids: e.target.value
                        .split(",")
                        .map((id) => id.trim())
                        .filter((id) => id),
                    }))
                  }
                  placeholder="Masukkan labor IDs dipisahkan koma"
                />
              </Form.Group> */}

              {/* <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Labor Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={formData.labor_notes.join("\n")}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      labor_notes: e.target.value
                        .split("\n")
                        .filter((note) => note.trim()),
                    }))
                  }
                  placeholder="Masukkan catatan labor (satu per baris)"
                />
              </Form.Group> */}

              <Modal.Footer>
                <Button variant="secondary" onClick={resetForm}>
                  Batal
                </Button>
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading
                    ? "Menyimpan..."
                    : editingTemplate
                    ? "Update"
                    : "Simpan"}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
      </Modal.Body>
    </Modal>
  );
};

export default ServiceTemplateManager;
